export default "__VITE_ASSET__08209d0a__"